import angular from 'angular'
import formRepeatSectionModule from '../formRepeatSection/formRepeatSection'

import addressSelectComponent from './addressSelect.component'

export default angular.module('app.common.forms.addressSelect', [formRepeatSectionModule.name])
  .directive('addressSelect', addressSelectComponent)
